import { render, staticRenderFns } from "./awemeList.vue?vue&type=template&id=3c778549&scoped=true"
import script from "./awemeList.vue?vue&type=script&lang=js"
export * from "./awemeList.vue?vue&type=script&lang=js"
import style0 from "./awemeList.vue?vue&type=style&index=0&id=3c778549&prod&lang=less&scoped=true"
import style1 from "./awemeList.vue?vue&type=style&index=1&id=3c778549&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c778549",
  null
  
)

export default component.exports